var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_864_626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8536 0.646396C11.7598 0.552659 11.6327 0.5 11.5001 0.5C11.3675 0.5 11.2404 0.552659 11.1466 0.646396L6 5.79299L0.853408 0.646396C0.759643 0.552659 0.632487 0.5 0.499902 0.5C0.367318 0.5 0.240161 0.552659 0.146396 0.646396C0.0526586 0.740161 0 0.867318 0 0.999902C0 1.13249 0.0526586 1.25964 0.146396 1.35341L5.29299 6.5L0.146396 11.6466C0.0526586 11.7404 0 11.8675 0 12.0001C0 12.1327 0.0526586 12.2598 0.146396 12.3536C0.240161 12.4473 0.367318 12.5 0.499902 12.5C0.632487 12.5 0.759643 12.4473 0.853408 12.3536L6 7.20701L11.1466 12.3536C11.2404 12.4473 11.3675 12.5 11.5001 12.5C11.6327 12.5 11.7598 12.4473 11.8536 12.3536C11.9473 12.2598 12 12.1327 12 12.0001C12 11.8675 11.9473 11.7404 11.8536 11.6466L6.70701 6.5L11.8536 1.35341C11.9473 1.25964 12 1.13249 12 0.999902C12 0.867318 11.9473 0.740161 11.8536 0.646396Z",
    fill: "#696969"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_864_626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.f3db60eca9a56361e77d74646bacc0fd.svg";
export { ForwardRef as ReactComponent };